var map = {
	"./animal.JPG": 92,
	"./closet.jpeg": 93,
	"./food.JPG": 94,
	"./photographer.jpeg": 95,
	"./plantMom.jpeg": 96,
	"./tennising.jpeg": 97,
	"./travel.jpeg": 98,
	"./wanderer.jpeg": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;